// extracted by mini-css-extract-plugin
export default {"incidents":"Incidents_incidents__Euij0","iconWrapper":"Incidents_iconWrapper__CoPCt","iconBg":"Incidents_iconBg__Tw+vl","title":"Incidents_title__ZgSLM"};